// eslint-disable-next-line no-shadow
export enum EventNames {
  DELIVERY_EDIT_BUTTON_CLICKED = "Delivery Edit Button Clicked",
  DELIVERY_DELETE_BUTTON_CLICKED = "Delivery Delete Button Clicked",
  DELIVERY_DELETE_CONFIRM_CLICKED = "Delivery Delete Confirm Clicked",
  DELIVERY_DELETE_CANCEL_CLICKED = "Delivery Delete Cancel Clicked",
}
